<template>
  <button :class="[type, size, 'reset']">{{ text }}</button>
</template>

<script>
export default {
  name: "VButton",
  props: {
    size: {
      type: String,
      default: "normal"
    },
    text: {
      type: String,
      default: "Button"
    },
    type: {
      type: String,
      default: "primary"
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/variables.scss";
button {
  border-style: none;
  border-radius: 0;
  color: $white;
  display: inline-block;
  font-size: 1rem;
  line-height: 1.5;
  margin: 5px;
  padding: 0.25rem 1.5rem;
  font-weight: bold;
  text-transform: uppercase;
  &:hover {
    cursor: pointer;
  }

  // Types
  &.primary-old {
    background-image: linear-gradient(to right, $blue-green, $primary);
    transition: all 0.6s;

    &:hover {
      background-image: linear-gradient(to right, $primary, $blue-green);
    }
  }
  &.primary {
    background-color: $primary;
    transition: all 0.6s;

    &:hover {
      background-color: lighten($primary, 10%);
    }
  }
  &.secondary {
    background-color: #fff;
    color: $dark-gray;

    &:hover {
      background-color: $dark-gray;
      color: #fff;
    }
  }
  &.warning {
    background-color: $orange;

    &:hover {
      background-color: lighten($orange, 10%);
    }
  }
  &.danger {
    background-color: $red;

    &:hover {
      background-color: lighten($red, 10%);
    }
  }
  &.cta {
    background-color: $light-green;
    &:hover {
      background-color: lighten($light-green, 10%);
    }
  }
  &.white {
    background-color: $white;
    color: $light-green;
    &:hover {
      background-color: lighten($white, 10%);
    }
  }
  &.black {
    background-color: $black;
    color: $white;
    &:hover {
      background-color: lighten($black, 10%);
    }
  }
  &.outline {
    background-color: transparent;
    color: $black;
    border: solid $black 1px;
    &:hover {
      background-color: lighten($black, 10%);
      color: $white;
    }
  }
  // Sizes
  &.small {
    font-size: 0.75rem;
    padding: 0.2rem 1rem;
  }
  &.large {
    font-size: 1.25rem;
    padding: 0.5rem 1rem;
  }
}
</style>
